module.exports = __webpack_public_path__ + "img/service2880.abb19085.png";